import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import MessageFormPage from './pages/MessageFormPage';
import MyMessagesPage from './pages/MyMessagesPage';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import QRCodePage from './pages/QRCodePage';
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from './utils/firebase';
import { ref, onValue } from "firebase/database";
import { createContext, useContext } from "react";
import ResetPasswordPage from './pages/ResetPasswordPage';
import ManagementPage from './pages/ManagementPage';
import HelpNotificationsPage from './pages/HelpPage';
import NativePage from './pages/NativePage';
import LoadingSpinner from './components/LoadingSpinner';
import { initAnalytics } from './utils/analytics';
import { ToastProvider } from './components/toast/ToastContext';

export const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

function App() {
  //user structure:
  //user + userdata
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const onUserLoggedIn = (currentUser) => {
    const userRef = ref(db, "users/" + auth.currentUser.uid);
    onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        setUser({ ...currentUser, data: userData });
        setLoading(false);
        if (document.location.href.endsWith("/")) {
          document.location += "home";
        }
      } else {
        console.log("Žiadne dáta");
      }
    }, (error) => {
      console.error("Chyba listenera:", error);
    });
  }


  useEffect(() => {
    // setLoading(true);
    initAnalytics();

    setLoading(true)
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      const ignoreStateChange = localStorage.getItem("ignoreAuthStateChange");
      if (!ignoreStateChange || ignoreStateChange === "false") {
        //user was signed out
        if (auth.currentUser == null) {
          setUser(null);
          setLoading(false)
          return;
        }

        //user is signed in
        onUserLoggedIn(currentUser);
      }
    });

    return () => unsubscribe(); // cleanup
  }, []);

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <ToastProvider>
      <AuthContext.Provider value={{ user, loading, onUserLoggedIn }}>
        <BrowserRouter>
          <Routes>
            <Route path="/my/*" element={<MyMessagesPage />} />
            <Route path="/help" element={<HelpNotificationsPage />} />
            <Route path="/qr" element={<QRCodePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/man" element={<ManagementPage />} />
            <Route path="/reset-password/*" element={<ResetPasswordPage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/legal" element={<NativePage content="legal.html" />} />
            <Route path="/gdpr" element={<NativePage content="gdpr.html" />} />
            <Route path="/cookies" element={<NativePage content="cookies.html" />} />
            <Route path="/*" element={<MessageFormPage />} />
          </Routes>
        </BrowserRouter>
      </AuthContext.Provider>
    </ToastProvider>
  );
}

export default App;
